import {
  DataRangeFilterEnum,
  getDataRangeFilterLabel,
  type DateRangeFilterOption,
} from '@/constants/dates';

/** Tax document vault presets. */
export const taxDocumentsVaultDateFilters: DataRangeFilterEnum[] = [
  DataRangeFilterEnum.Trailing1Year,
  DataRangeFilterEnum.Trailing2Years,
  DataRangeFilterEnum.AllTime,
];

export const taxDocumentsVaultDateFilterOptions: DateRangeFilterOption[] =
  taxDocumentsVaultDateFilters.map((filter) => ({
    filter,
    label:
      filter === DataRangeFilterEnum.AllTime
        ? 'All'
        : getDataRangeFilterLabel(filter),
  }));

/**
 * Maps {@link DataRangeFilterEnum} to the Documents2 `DateInterval` param for tax documents.
 * API uses negative year counts (`Trailing1Year` → `-1`, `Trailing2Years` → `-2`).
 */
export function toTaxDocumentsDateIntervalApiValue(
  filter: DataRangeFilterEnum,
): string {
  switch (filter) {
    case DataRangeFilterEnum.Trailing1Year:
      return '-1';
    case DataRangeFilterEnum.Trailing2Years:
      return '-2';
    case DataRangeFilterEnum.AllTime:
      return '';
    default:
      throw new Error(`Unsupported tax documents vault date filter: ${filter}`);
  }
}
